import { useEffect, useState, type RefObject } from "react";

export function useFitRowCount(
  containerRef: RefObject<HTMLElement | null>,
  rowHeight = 52,
  minRows = 4
): number {
  const [rowCount, setRowCount] = useState(minRows);

  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;

    const measure = () => {
      const h = el.clientHeight;
      if (h <= 0) return;
      const fit = Math.max(minRows, Math.floor(h / rowHeight));
      setRowCount(fit);
    };

    measure();
    const observer = new ResizeObserver(measure);
    observer.observe(el);
    return () => observer.disconnect();
  }, [containerRef, rowHeight, minRows]);

  return rowCount;
}
